import React from 'react'

function Primavera() {
  return (
    <div>Primavera</div>
  )
}

export default Primavera